import React from 'react';
import { coaches } from '../data/coaches';

/**
 * The product has no buyers yet, so there is no rating to show.
 * Once real reviews exist, add the star row and the real average/count back.
 */
export function RatingProof() {
  const faces = coaches.slice(0, 5);
  return <div className="flex items-center gap-3" data-id="element-270" data-mp="3ghajvnlcp69x">
      <div className="flex -space-x-2.5" data-id="element-271" data-mp="3gi2fuziv160q">
        {faces.map(coach => <img key={coach.name} src={coach.avatar} alt="" width={36} height={36} className="h-9 w-9 rounded-full object-cover ring-2 ring-cream" data-id="element-272" data-mp="3lh597mph9nsv" />)}
      </div>
      <div className="leading-tight" data-id="element-273" data-mp="3uez3yt7lg9dx">
        <p className="whitespace-nowrap text-[13px] font-semibold text-ink" data-id="element-274" data-mp="3bafjb4c0ebo">
          Built for mixed groups, ages 5–11
        </p>
        <p className="mt-1 whitespace-nowrap text-[12px] text-ink-soft" data-id="element-275" data-mp="204c7hgkpjvla">
          US · UK · Canada · Australia
        </p>
      </div>
    </div>;
}